import { render, staticRenderFns } from "./channel.overview.vue?vue&type=template&id=765cb778&scoped=true&"
import script from "./channel.overview.vue?vue&type=script&lang=js&"
export * from "./channel.overview.vue?vue&type=script&lang=js&"
import style0 from "./channel.overview.vue?vue&type=style&index=0&id=765cb778&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765cb778",
  null
  
)

export default component.exports